import React, { useEffect, useState , useContext} from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Context }  from './../Auth.Context';
import { translate } from './../helpers/intl_helpers';
import logoIcon from './../assets/images/logo.svg';
import locationIcon from './../assets/images/location-icon.svg';
import searchIconBlack from './../assets/images/black-search-icon.png';
import unitedKingdomIcon from './../assets/images/united-kingdom.png';
import uaeIcon from './../assets/images/uae.png';
import russiaFlagIcon from './../assets/images/russia-flag.png';
import userIcon from './../assets/images/user-icon.svg';
import { logout,customConfirmBox , camelCaseWord , callBackendAPI} from './../helpers/common';
import { ENGLISH_LANGUAGE_CODE, ARABIC_LANGUAGE_CODE,RUSSIAN_LANGUAGE_CODE,GOOGLE_MAP_KEY,STATUS_SUCCESS}  from './../config/global_constants';
import Cookies 	from 'universal-cookie';
import Autocomplete from "react-google-autocomplete";
import { useGeolocated } from "react-geolocated";
import { useNavigate } from "react-router-dom";
import $  from 'jquery';


export default function Header({pageType="home", subPageType="", updateParentCartList}) {
	const navigate = useNavigate(); 
	const [location, setLocation] = useState({
		lat: '',
		lng: '',
		address: "",
	  });
	  const [humburgerMenu, setHumburgerMenu] = useState(false);

	const { coords, isGeolocationAvailable, isGeolocationEnabled} =
	useGeolocated({
		positionOptions: {
			enableHighAccuracy: false,
		},
		userDecisionTimeout: 5000,
	});

	const fetchAddress = (lat, lng) => {
		fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAP_KEY}`)
		  .then((response) => response.json())
		  .then((data) => {
			if (data.status === "OK") {
			  setLocation((prev) => ({
				...prev,
				address: data.results[0].formatted_address,
			  }));
			}
		  })
		  .catch((error) => console.error("Error fetching address:", error));
	  };

	/** Update location when geolocation is available */
	useEffect(() => {
		if (coords) {
			setLocation({ lat: coords.latitude, lng: coords.longitude });
		}
	}, [coords]);


	/** Set default address on load */
	useEffect(() => {
		fetchAddress(location.lat, location.lng);
	}, [location.lat, location.lng]);

	const handleAddressSelect = (place) => {
		if (place && place.geometry) {
			setLocation({
				lat: place.geometry.location.lat(),
				lng: place.geometry.location.lng(),
				address: place.formatted_address,
			});
		}
	};

	const { pathname } = useLocation();
	const cookies 	=	new Cookies();
	const [userDetails, setUserDetails] 		=	useContext(Context);
	const [loginUrl, setLoginUrl]   			=	useState(false);
	var language =	cookies.get('preferred_language') ? cookies.get('preferred_language'):ENGLISH_LANGUAGE_CODE;

	useEffect(()=>{
		if(pathname.indexOf("/login") === -1 && pathname.indexOf("/sign-up") === -1 && pathname.indexOf("/verify") === -1 && pathname.indexOf("/forgot-verify") === -1 && pathname.indexOf("/reset-password") === -1 && pathname.indexOf("/return-and-refund") === -1 && pathname.indexOf("/term-condition") === -1 && pathname.indexOf("/privacy-policies") === -1 && pathname.indexOf("/satisfaction-guarantee" && pathname.indexOf("/shipping") === -1 && pathname.indexOf("/policies") === -1)){
			setLoginUrl("/login?redirect="+pathname);
		}else{
			setLoginUrl("/login");
		}
	},[pathname])

	async function Logout() {
		if(await customConfirmBox(translate('logout.confirm_message'))){
			setUserDetails({});
			logout();
		}
	}// end Logout()	

	/**
	* For this property mark as favorite / unfavorite
	*/
	const changeLanguage = async (e, language) => {
		const cookies 	=	new Cookies();
		e.preventDefault();
		cookies.set('preferred_language',language);
		window.location.reload();
	}// end markAsFavorite()

	const handleLocationIconClick = () => {
		navigate(`/property?lat=${location.lat}&lng=${location.lng}`);
		setHumburgerMenu(false);
	};

	useEffect(() => {
		if (humburgerMenu) {
			document.body.classList.add('stop-scroll');
		} else {
			document.body.classList.remove('stop-scroll');
		}
	}, [humburgerMenu]);	

	return <>
	<header>
        <div className="container">
			<div className="header">
				<Link to="/" className="logo" onClick={()=>{setHumburgerMenu(false)}}><figure><img src={logoIcon} alt="img"/></figure></Link>
				<div className="navbar">					
					<div className="dropdown locationdropdown">
						<Autocomplete
						apiKey={GOOGLE_MAP_KEY}
						options={{
							types: [], // Allows locality, sub-locality, neighborhoods, streets, etc.
							 componentRestrictions: { country: "AE" },
						}}
						onPlaceSelected = {handleAddressSelect}
						onChange={(e) => setLocation({ ...location, address: e.target.value })}
						placeholder  = {translate("headers.location.enter_a_location")}
						defaultValue = {`${location.address}`}
						language     = {language}
						/><i onClick={handleLocationIconClick} style={{ cursor: 'pointer' }} ><img src={searchIconBlack} alt="img"/></i>
					</div>
					<div className="navigation">
						<div className={`menu-button ${humburgerMenu ? 'open' : ''}`} onClick={()=>{setHumburgerMenu(true)}}>
							<span /><span /><span />
						</div>
						<div data-breakpoint="1199" className={`flexnav lg-screen ${humburgerMenu ? 'show' : ''}`}>
							<ul>
									<li>
										<div className="dropdown locationdropdown">
											<Autocomplete
												apiKey={GOOGLE_MAP_KEY}
												options={{
													types: [], // Allows locality, sub-locality, neighborhoods, streets, etc.
													componentRestrictions: { country: "AE" },
												}}
												onPlaceSelected={handleAddressSelect}
												onChange={(e) => setLocation({ ...location, address: e.target.value })}
												placeholder={translate("headers.location.enter_a_location")}
												defaultValue={`${location.address}`}
												language={language}
											/><i onClick={handleLocationIconClick} style={{ cursor: 'pointer' }} ><img src={searchIconBlack} alt="img" /></i>
										</div>	
									</li>
								<li>
									<Link to="#"
										onClick={(e) => {
											e.preventDefault();
											setHumburgerMenu(false);
											navigate('/property');
										}}
									>{translate("headers.destinations")}
									</Link>
								</li>
								<li>
									<Link to="#"
										onClick={(e) => {
											e.preventDefault();
											setHumburgerMenu(false);
											navigate('/property?offers=true');
										}}
									>{translate("headers.offers")}
									</Link>
								</li>
								<li>
									<Link to="#"
										onClick={(e) => {
											e.preventDefault();
											setHumburgerMenu(false);
											navigate('/help');
										}}
									>{translate("headers.help")}
									</Link>
								</li>							
								<li className="countrydropdown">
									<div className="dropdown">
									  	<button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
											{language === ENGLISH_LANGUAGE_CODE ? <><i><img src={unitedKingdomIcon} alt='img' /></i> {translate('headers.english')} </>:null}
											{language === ARABIC_LANGUAGE_CODE ? <><i><img src={uaeIcon} alt='img' /></i> {translate('headers.arabic')} </>:null}
											{language === RUSSIAN_LANGUAGE_CODE ? <><i><img src={russiaFlagIcon} alt='img' /></i> {translate('headers.russian')} </>:null}
										</button>
									  	<ul className="dropdown-menu">
											<li><Link className="dropdown-item" to="#" onClick={(event)=>{changeLanguage(event,ENGLISH_LANGUAGE_CODE)}}><i><img src={unitedKingdomIcon} alt="img" /></i> {translate("headers.english")}</Link></li>
											<li><Link className="dropdown-item" to="#" onClick={(event)=>{changeLanguage(event,ARABIC_LANGUAGE_CODE)}}><i><img src={uaeIcon} alt="img" /></i> {translate("headers.arabic")}</Link></li>
											<li><Link className="dropdown-item" to="#" onClick={(event)=>{changeLanguage(event,RUSSIAN_LANGUAGE_CODE)}}><i><img src={russiaFlagIcon} alt="img" /></i> {translate("headers.russian")}</Link></li>
										</ul>
									</div>
								</li>							
							</ul>
						</div>
					</div>					
					<div className="dropdown countrydropdown">
						<button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
							{language === ENGLISH_LANGUAGE_CODE ? <><i><img src={unitedKingdomIcon} alt='img' /></i> {translate('headers.english')} </>:null}
							{language === ARABIC_LANGUAGE_CODE ?<><i><img src={uaeIcon} alt='img' /></i> {translate('headers.arabic')} </>:null}
							{language === RUSSIAN_LANGUAGE_CODE ? <><i><img src={russiaFlagIcon} alt='img' /></i> {translate('headers.russian')} </>:null}
						</button>
					 	<ul className="dropdown-menu">
							 <li><Link className="dropdown-item" to="#" onClick={(event)=>{changeLanguage(event,ENGLISH_LANGUAGE_CODE)}}><i><img src={unitedKingdomIcon} alt="img" /></i> {translate("headers.english")}</Link></li>
							<li><Link className="dropdown-item" to="#" onClick={(event)=>{changeLanguage(event,ARABIC_LANGUAGE_CODE)}}><i><img src={uaeIcon} alt="img" /></i> {translate("headers.arabic")}</Link></li>
							<li><Link className="dropdown-item" to="#" onClick={(event)=>{changeLanguage(event,RUSSIAN_LANGUAGE_CODE)}}><i><img src={russiaFlagIcon} alt="img" /></i> {translate("headers.russian")}</Link></li>
						</ul>
					</div>
						{userDetails && userDetails._id ? (
							<div className="dropdown login-dropdown p-0" >
								<button className=" dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" onClick={()=>{setHumburgerMenu(false)}}>
									{userDetails.profile_image ? (
										<img src={userDetails.image_url + userDetails.profile_image} alt="img" />
									) : <Link to="#"><img src={userIcon} alt="img" /></Link>}
									<span className="text-truncate">{userDetails.full_name ? camelCaseWord(userDetails.full_name) : ''}</span>
								</button>
								<ul className="dropdown-menu" >
									<li>
										<Link to="#"
										className="dropdown-item"
										onClick={(e) => {
											e.preventDefault();
											setHumburgerMenu(false);
											navigate('/my-profile');
										}}
										>
										{translate('header.my_profile')}
										</Link>
									</li>
									<li><Link to="#" className="dropdown-item" onClick={() => Logout()}>{translate("header.logout")} </Link> </li>
								</ul>
							</div>
						) : (
								<div className="btn btn-outline">
									<Link to="#" onClick={(e) => {
										e.preventDefault();
										setHumburgerMenu(false);
										navigate('/login');
									}} ><img src={userIcon} alt="img" /></Link><Link to={loginUrl}>{translate("header.log_in")} </Link> or <Link to="/sign-up">{translate("header.create_account")}</Link></div>
						)}
				</div>            
			</div>
        </div>
    </header>
	

	</>
};
